module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/24-379732424c5f59dda282ad09fd3c2291.png";